const THEME_VERSION = 'dieselr-2025-v3';

// Utility: detect bots
function isBot() {
  return /bot|crawl|spider|slurp|duckduck|bing|archive|google/i.test(navigator.userAgent);
}

function clearOldCookiesAndStorage() {
  try {
    // Clear cookies
    document.cookie.split(";").forEach(cookie => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Clear storages
    localStorage.clear();
    sessionStorage.clear();

    // Set the new theme version flag
    localStorage.setItem('themeVersion', THEME_VERSION);

    // Soft reload
    window.location.reload();
  } catch (e) {
    console.warn('Error during theme reset:', e);
  }
}

// Manual trigger (for debugging or CTA button)
window.triggerManualRefresh = clearOldCookiesAndStorage;

// Automatic refresh (only if not bot and version changed)
const currentVersion = localStorage.getItem('themeVersion');
if (currentVersion !== THEME_VERSION && !isBot()) {
  // Delay to avoid layout thrashing
  window.addEventListener('load', () => {
    setTimeout(() => {
      clearOldCookiesAndStorage();
    }, 500); // wait 500ms after load
  });
}
